import type { ColumnFiltersAction } from "./actions";
import type { ColumnFiltersState } from "./state";

export function columnFiltersReducer(
  state: ColumnFiltersState,
  { type, payload }: ColumnFiltersAction,
): ColumnFiltersState {
  const next: ColumnFiltersState = { filters: {}, columns: {} };
  switch (type) {
    case "set_columns":
      // Reset the columns to the content of the payload.
      // Preserve only the filters that are in the new set of columns.
      for (const column of payload) {
        next.columns[column.messagePathId] = column;
        if (Object.hasOwn(state.filters, column.messagePathId)) {
          next.filters[column.messagePathId] =
            state.filters[column.messagePathId];
        }
      }
      return next;
    case "delete_filter":
      // Preserve columns from the old state.
      // Clear the given filter by ID from the new state.
      next.columns = { ...state.columns };
      next.filters = { ...state.filters };
      delete next.filters[payload.columnId];
      return next;
    case "set_filter":
      // Preserve columns from the old state.
      // Set the new filter by ID iff it matches a known column.
      next.columns = { ...state.columns };
      next.filters = { ...state.filters };
      if (Object.hasOwn(state.columns, payload.columnId)) {
        next.filters[payload.columnId] = payload.filter;
      }
      return next;
  }
  // No default or other return means the compiler will fail if the switch is non-exhaustive.
}
